import { Flex, Group, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { BsExclamationCircleFill } from 'react-icons/bs';
import { DEFAULT_ICON_SIZE } from 'utils/general';

interface BannerProps {
  message: string;
  bg: string;
  color?: string;
  action?: ReactNode;
}

export const Banner = ({ message, bg, color = 'var(--mantine-color-white)', action }: BannerProps) => {
  return (
    <Flex h={48} mx={-32} mt={-32} mb={18} bg={bg} align={'center'} justify={'center'}>
      <Group gap={'xs'}>
        <BsExclamationCircleFill color={color} size={DEFAULT_ICON_SIZE} />
        <Text fw={250} c={color}>
          {message}
        </Text>
        {action}
      </Group>
    </Flex>
  );
};
